/* eslint-disable radix */
import { UnitEnum } from '../model';

// 数字缩放保留小数
export const formatNumber = (
  value: string | number,
  zoom = 1, // 缩放比
  precision = 2 // 精度
) => {
  const num = Number(value);
  if (!isNaN(num)) {
    return Number((num * zoom).toFixed(precision));
  }
  return 0;
};

// 数字四舍五入保留两位小数
export const fixed2 = (val: string | number, defaultValue?: number) => {
  if (isNaN(+val) && defaultValue) {
    return defaultValue;
  }
  if ((+val || +val === 0) && !isNaN(+val)) {
    return Math.round(+val * 100) / 100;
  }
  return 0;
};

export const addUnit = (val: string | number, unit?: UnitEnum) =>
  `${val + (unit ? unit : '')}`;

// 个位补0
export const bitComplementZero = (num: number) => {
  const numString = num.toString();
  return numString[1] ? numString : `0${numString}`;
};

// 否是有效number
export const isNumeric = (str: string): boolean => {
  const num = Number(str);
  return !Number.isNaN(num);
};

//  string|undefined-->number小数点后两位-四舍五入
export const getPrice = (price?: number | string) => {
  const num = Number(price);
  if (price === undefined || isNaN(num)) {
    return { amount: '', unit: '', text: '' };
  }

  const unit = '¥';
  const amount = num.toFixed(2);

  return {
    amount,
    unit: '¥',
    text: `${unit}${amount}`,
  };
};

export function moneyChinese(money: number) {
  // 大写数字
  const bigNumbers = [
    '零',
    '壹',
    '贰',
    '叁',
    '肆',
    '伍',
    '陆',
    '柒',
    '捌',
    '玖',
  ];
  // 单位
  const units = [
    '分',
    '角',
    '元',
    '拾',
    '佰',
    '仟',
    '万',
    '拾',
    '佰',
    '仟',
    '亿',
    '拾',
    '佰',
    '仟',
    '兆',
    '拾',
    '佰',
    '仟',
  ];

  // 处理输入为 0 的情况
  if (money === 0) {
    return '零元整';
  }

  // 将金额转换为字符串并保留两位小数
  const str = parseFloat(String(money)).toFixed(2);
  // 分离整数部分和小数部分
  const [integerPart, decimalPart] = str.split('.');

  let integerResult = '';
  let decimalResult = '';
  let zeroCount = 0;

  // 处理整数部分
  if (integerPart !== '0') {
    for (let i = 0; i < integerPart.length; i++) {
      const num = parseInt(integerPart[i]);
      const unitIndex = integerPart.length - i + 1;

      if (num === 0) {
        zeroCount += 1;
      } else {
        if (zeroCount > 0) {
          integerResult += bigNumbers[0];
        }
        integerResult += bigNumbers[num] + units[unitIndex];
        zeroCount = 0;
      }
    }
    // 处理零的情况
    integerResult = integerResult.replace(/零{2,}/g, '零');
    integerResult = integerResult.replace(/零([元万亿兆])/g, '$1');
    integerResult = integerResult.replace(/(兆|亿|万)元/g, '$1');
  }

  // 处理小数部分
  if (decimalPart !== '00') {
    for (let i = 0; i < decimalPart.length; i++) {
      const num = parseInt(decimalPart[i]);
      if (num !== 0) {
        decimalResult += bigNumbers[num] + units[1 - i];
      }
    }
  }

  // 合并整数部分和小数部分结果
  let result = '';
  if (integerResult) {
    result = integerResult;
    if (decimalResult) {
      result += decimalResult;
    } else {
      result += '整';
    }
  } else {
    result = decimalResult;
  }

  return result;
}
